
function About() {
    return(
        <div>
            <h1>About Us</h1>
            <p class="subtitle">
                We love a good story, and finding the story of our home has been a beloved (and sometimes mindboggling frustrating) journey for us.
            </p>
            <p></p>
        </div>
    )
}

export default About
